import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {AdvertisementService_SponsorshipInfoLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.grpc.lazy';
import {SponsorshipInfoRequest_Target} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.types';

export const useSponsoredProductRequest = ({
  productId,
  promotionId,
}: {
  productId?: number;
  promotionId?: string;
}) => {
  const target: SponsorshipInfoRequest_Target = productId
    ? {type: {$case: 'productId', productId}}
    : {type: {$case: 'promotionId', promotionId: promotionId!}};

  return useGrpcRequest(
    AdvertisementService_SponsorshipInfoLazy,
    {target},
    // this is needed so that we do not show stale data before the response comes in
    {
      disabled: !productId && !promotionId,
      keepPreviousData: false,
      staleTime: 0,
    },
  );
};
